<!-- This is where we will insert the dynamic components -->
<nscf-dynamic [theme]="theme"></nscf-dynamic>
